import { render } from "./QuarterlyLeaveBalanceEmails.vue?vue&type=template&id=28473e90&scoped=true"
import script from "./QuarterlyLeaveBalanceEmails.vue?vue&type=script&lang=js"
export * from "./QuarterlyLeaveBalanceEmails.vue?vue&type=script&lang=js"

import "./quarterly-leave-balance-emails.scss?vue&type=style&index=0&id=28473e90&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/orangehrm/orangehrm/src/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-28473e90"]])

export default __exports__